import styled from "styled-components"


import close from '@/img/user-new/close.png'
import closeIcon from '@/img/activity22/close.png'
import titileBack from '@/img/active20/title-back@2x.png'
import sbg1 from '@/img/activity50/bg2@2x.png'
import {color1,bg_color1,activity_state_color, card_bg_color, box_shadow} from '@/styles/theme'
import Star1 from '@/img/activity22/star1@2x.png'
import Star2 from '@/img/activity22/star2@2x.png'

// 分享H5样式 

export const ShareContainer = styled.div`
  background: #F0385D;
  min-height: 100vh;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  .sticky {
    position: sticky;
    left: 0;
    top: 0px;
    background-color: #F1385B;
    font-size: 0px;
    vertical-align: middle;
    z-index:99;
    margin-top: 2vw;
    height: 32px;
  }
  .user_box{
    position:absolute;
    left:0;
    top:7.8vw;
    width: 100%;
    text-align:center;
    padding-top: 8.4vw;
  }
  .avatar{ 
    width: 18.667vw;
    height: 18.667vw;
    border:3px solid #ffffff;
    border-radius: 50%;
  }
  .nickname{
    margin: 1.8vw auto 2.3vw;
    display: inline-block;
    height: 28px;
    font-size: 15px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 28px;
    padding: 0 22px;
    background-image: linear-gradient(90deg, #FACA3F, #FB8F24);
    // background: #FE7259;
    
    border-radius: 24px;
    
  }
  .title-box{
    text-align: center;
    .title {
      text-align: center;
      color: white;
   

      position: relative;
      display: inline-block;
      font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 38px;
      // &::before,  &::after{
      //   content: '';
      //   display: block;
      //   width: 20px;
      //   height:14px;
      //   position: absolute;
      //   top: 50%;
      //   margin-top: -10px;
      //   // background: white;
      //   background-size: 100%;
      // } 
      // &::before{
      //   left: -30px;
      //   background-image: url(${Star2});
        
      // }
      // &::after{
      //   right: -30px;
      //   background-image: url(${Star1});
      // }
    }
  }
  .title-box+.message {
    text-align:center;
    margin-top: -12px;
    padding-top: 5px;
    letter-spacing: 0px;
    padding-bottom: 7px;
    font-size: 12px;
    font-weight: 300;
    color: rgba(255,208,218);
  }
  .tip{
    font-size:17px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #FFFFFF;
  }
  .header{
    margin-top:-47px;
    width:100%;
  }
  img.footer {
    display:block;
    width: calc(100% - 40px);
    margin: 15px auto 0;
  }
  footer {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FF909E;
    text-align: center;
    line-height: 1.5;
    padding: 12px 0;
  }
  >img{
    max-width:100%;
  }
  .show{
    display:block;
  }
  .hidden{
    display:none;
  }
`

export const RegistContainer = styled.div`
  margin: -44vw auto 0;
  position: relative;
  z-index:2;
  width: calc(100% - 24px);
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url(${sbg1});
  background-repeat: no-repeat;
  background-size: calc(100% - 24px);
  background-position: 12px 0;
  width: 100%;
  height: 122vw;
  padding-top: 50.6vw;
  .container{
    margin:auto;
    // display: ${props=>props.Empty? 'flex':'block '};
    // justify-content: center;
    // align-items: ${props=>props.Empty?  'baseline':'center'};
    box-sizing: border-box;
    .message{
      color: #E0B6A4;
      line-height: 18px;
      text-align:center;
      font-size:12px;
    }
  }
  .tips {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #868686;
    line-height: 43px;
} 
`

export const FormCotainer = styled.div`
    padding:9vw 22px;
  .form-item{
    margin: 3.5vw auto;
    padding: 3.7vw 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 86.4vw;
    overflow: hidden;
    height: 13.86vw;
    box-sizing: border-box;
    max-height: 50px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #FF8B23;
    // border-image: linear-gradient(0deg, #FF8B23, #FFB016) 10 10;

    .am-list-item{
      width: 100%;
      background: #ffffff;
    }
    .am-list-item:not(:last-child) .am-list-line::after{
      background-color: transparent;
    }
    .am-list-item:not(:last-child) .am-list-line {
      border: none;
    }
    .am-list-item .am-input-clear{
      background-image: url(${close});
      background-color: transparent;
      background-size : 21px;
      background-position: 0 0;
      border-radius: 0;
    }
    .button{
      margin-left: 10px;
      margin-right: 10px;
      width: 94px;
      text-align: right;
    //   background: #F6F6F8;
      border: none;
      outline: none;
      color: #9696A6;
    }
    .active{
      color: #9C775A;
    }
 
  }
  .am-list-item.am-input-item{
    padding-left: 10px;
  }
  .am-list-item{
    .am-input-label{
      width: 32px;
      font-size: 14px;
      color: #333;
    }
    .am-input-control input {
      font-size: 16px;
      color: #333;
    }
    .am-input-label{
      position: relative;
      overflow: visible;
    }
    .am-input-label:before{
      position: absolute;
      content: '';
      right: -1px;
      top: -2px;
      width: 1px;
      height: 24px;
      background: #979797;
      transform: scale(0.8);
    }
  }
  .text{
      flex: 1;
      background: #F6F6F8;
      border: none;
      outline: none;
      .am-input-control input{
        font-size: 14px;
      }
    }
  .regist {
    text-align: center;
    > img{
        max-height: 60px;
        width: 69.3vw;
        margin:auto;
    }
  }
 
`
  
export const RegistModalContent = styled.div`
  background: white;
  padding: 30px 15px 30px;
  position: relative;
  z-index: 300;
  .regist-modal-content-text{
    text-align: center∂;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;
  }
  .regist-modal-content-group{
    margin: 24px auto 0;
    display: flex;
    justify-content: space-around;
  }
  .regist-modal-content-button{
    width: 40.2vw;
    font-size: 14px;
    text-align: center;
    line-height: 44px;
    color: #ffff;
    font-weight: 500;
    border-radius: 22px;
    border:none;

    background-image: linear-gradient(90deg, #FFB804, #EFA319);
    background-size: 100% 100%;
  }
  .regist-modal-button{
    display: flex;
    align-items: center;
    .modal-button{
      background-image: linear-gradient(90deg, #FFB804, #EFA319);
      background-size: 100% 100%;
      border-radius: 20px;
      margin: 0 5px;
      // width: 151px;
      width: 35.2vw;
      height: 40px;
      font-size: 14px;
      color:#ffffff;
      line-height:40px;
    }
  }
`

export const ActivtyContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 44px;
  /* margin-bottom: 40px; */
  min-height: calc(100vh - 84px);
  background: ${bg_color1};
  box-sizing: border-box;
`
export const ActiveCard = styled.div`
  width: calc(100% - 20px);
  margin: 6px auto 24px;
  box-sizing: border-box;
  background: ${card_bg_color};
  box-shadow: ${box_shadow};
  border-radius: 6px;
  .img-container{
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 6px 6px 0 0;
    img{
      border-radius: 6px 6px 0 0;
      width: 100%;
      height: 100%;
      filter: ${props=>props.state=== 2? 'grayscale(100%) saturate(0.1)': 'none'};
    }
    .activity-state{
      position: absolute;
      top: 0;
      left: 0;
      &:before{
        position: absolute;
        content: '活动已结束';
        font-size: 12px;
        font-weight: 600;
        color: ${activity_state_color}; 
        top: 0;
        left: 0;
        z-index: 999;
        width:88px;
        height: 32px;
        background: ${card_bg_color};
        border-radius: 5px 0px 16px 0px;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  .content{
    padding: 16px;
    .title{
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
      color: ${color1};
      line-height: 20px;
    }
    .date{
      font-size: 12px;
      font-weight: 400;
      color: #646472;
      line-height: 17px;
    }
  }
`


export const CTitle = styled.div`
  .title{
    position: absolute;
    top:  0;
    top: 0;
    left: 45px;
    right: 45px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #511e21;
    font-weight: 600;
    color: #fff;
    background-image: url(${titileBack});
    // background-image: linear-gradient(180deg, #FFE600 0%, #FFC800 100%);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .back{
    width: calc(100% - 62px);
    height: 10px;
    position: absolute;
    top: 0;
    left: 31px;
    overflow: hidden;
    &:before{
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 29px;
      border-radius: 15px;
      background-color: #c93432;
    }
  }
  .prize-header{
    position: absolute;
    height: 81px;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
  }
`


export const Center =styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

`

export  const IconClose = styled.div`

  width: 40px;
  height:40px;
  position: absolute;
  z-index: 300;
  top: -40px;
  right: 0px;
  background-image: url(${closeIcon});
  background-size: 25px 25px;
  background-repeat: no-repeat;
  background-position: center center;

`

export const FlexBox = styled.div`
  margin: 0 12px;
  margin-top: -3vw;
  margin-bottom: 5vw;
  display: flex;
  background: #C71A3D;
  height: 28px;
  color: rgba(255,255,255,.8);
  line-height: 28px;
  font-weight: 600;
  font-size: 13px;
  border-radius: 14px;
  padding: 0 40px;
  justify-content: space-between;
  .flex-item {
    font-weight: 300;
    width: 105px;
    text-align: center;
    max-width: 105px;
   
    &.block {
      font-weight: 600;
      // height: 28px;
      color:#F1385B;
      background: #FFFFFF;
      border-radius: 14px;
    } 
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_50/share-pull-regist/style.js